module.exports = __webpack_public_path__ + "img/H-63-ER-1200-BB.c11ba1d4.png";